import { logger } from '@pkg/logger';

declare global {
  interface Window {
    CookieConsent?: {
      renew: () => void;
    };
  }
}

export interface ExposedFunction {
  id: string;
  name: string;
  description: string;
  category: string;
}

export interface ExposedFunctionRegistry {
  [key: string]: {
    name: string;
    description: string;
    category: string;
    execute: (...args: any[]) => void | Promise<void>;
  };
}

// Registry of exposed functions
// ADD more functions here
export const exposedFunctions: ExposedFunctionRegistry = {

  'open-gdpr-banner': {
    name: 'Open GDPR Banner',
    description: 'Open the GDPR banner on the page',
    category: 'Navigation',
    execute: () => {
      logger.info('Trying to open cookie banner');
      try {
        window?.CookieConsent?.renew();
      } catch (error) {
        logger.warn('Could not open cookie consent:', error);
      }
    },
  },

  'copy-to-clipboard': {
    name: 'Copy to Clipboard',
    description: 'Copy text to clipboard',
    category: 'Utility',
    execute: (...args: any[]) => {
      const text = Array.isArray(args[0]) ? args[0][0] : args[0];
      const textToCopy = text || 'No text provided';

      logger.info('Copy to clipboard called with args:', args);
      logger.info('Text to copy:', textToCopy);

      try {
        navigator.clipboard.writeText(textToCopy).then(() => {
          logger.info('Text copied to clipboard:', textToCopy);
        }).catch((error) => {
          logger.warn('Failed to copy to clipboard:', error);
        });
      } catch (error) {
        logger.warn('Failed to copy to clipboard:', error);
      }
    },
  },

};

export function getExposedFunctionsList(): ExposedFunction[] {
  return Object.entries(exposedFunctions).map(([id, func]) => ({
    id,
    name: func.name,
    description: func.description,
    category: func.category,
  }));
}

export function executeExposedFunction(functionId: string, ...args: any[]): void {
  const func = exposedFunctions[functionId];
  if (func) {
    func.execute(...args);
  } else {
    logger.error(`Exposed function '${functionId}' not found`);
  }
}

if (typeof window !== 'undefined') {
  (window as any).exposedFunctions = {
    execute: executeExposedFunction,
    list: getExposedFunctionsList,
  };
}
